import { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Point, StyledStatus } from './status.styled';
import { StatusProps } from './status.types';
import { Text } from '../text';

export const Status = observer(
  forwardRef<HTMLDivElement, StatusProps>(
    ({ children, withoutPoint = false, ...props }, ref) => {
      return (
        <StyledStatus ref={ref} {...props}>
          {!withoutPoint && (
            <Point color={props.color} disabled={props.disabled} />
          )}

          <Text truncate>{children}</Text>
        </StyledStatus>
      );
    }
  )
);
